// Cookie/consent category keys and localStorage key used by useCookieConsent.
// "necessary" (auth session cookie, referral_code cookie, gameplay local storage)
// is always active and cannot be disabled. "analytics" (Google Analytics 4) is
// off until the user explicitly opts in.
export const CONSENT_STORAGE_KEY = "leela_cookie_consent";

export const CONSENT_CATEGORIES = {
    NECESSARY: "necessary",
    ANALYTICS: "analytics",
};
